var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'min-vh-100':
            _vm.$route.path === '/login' || _vm.$route.path === '/registration',
    }},[_c('GlobalLoader'),(
            _vm.$route.path !== '/login' &&
            _vm.$route.path !== '/calendar' &&
            _vm.$route.path !== '/registration' &&
            _vm.$route.name !== 'WidgetPublicView' &&
            _vm.$route.name !== 'WidgetPublicViewPayment' &&
            _vm.$route.name !== 'CampaignPublicViewPayment'
        )?_c('div',{staticClass:"main-app",attrs:{"id":"page"}},[_c('div',{staticClass:"sidebar-new",class:_vm.sidebarOverrideBg},[_c('NewSideBar')],1),_c('div',{staticClass:"main-content"},[_c('NewHeader'),_c('div',{staticClass:"side-content",attrs:{"id":"content"}},[_c('router-view')],1)],1)]):_c('div',{staticClass:"min-vh-100 overflow-hidden"},[_c('GlobalLoader'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }